import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { dependenciesFromGlobalMetadata } from "@angular/compiler/src/render3/r3_factory";
import { GlobalService } from "./global.service";
interface token {
  token: string;
}
interface validarUser {
  hasError: boolean;
  errorDisplay: string;
}
interface login {
  errorNum: number;
  account: string;
  accounts: object;
  accountType: string;
  email: string;
  idParent: string;
  name: string;
  hasError: boolean;
  errorDisplay: string;
  errorDesc: string;
  token: string;
  subscriber: string;
  username: string;
  SSOAccessToken: string;
  requiredEmailUpdate: boolean;
  requiredPaperless: boolean;
  requiredQuestions: boolean;
  requiredAccountUpdate: boolean;
  requiredPasswordReset: boolean;
}
interface accountDetails {
  response(response: any, arg1: string);
  HasError: boolean;
  errorDisplay: string;
  ErrorDesc: string;
  SubscriberInfo: any[];
  AccounInfo: any;
}
interface doPayment {
  HasError: boolean;
  ErrorDesc: string;
  response: string;
}
interface getAcountsList {
  hasError: boolean;
  ErrorDesc: string;
  accounts: any;
}
interface accountRefresh {
  AccountList: any;
  hasError: boolean;
  ErrorDesc: string;
  accounts: object;
}
interface addAccount {
  hasError: boolean;
  errorDisplay: string;
}
interface setAsDefaultAccount {
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
}
interface getquestions {
  hasError: boolean;
  ErrorDesc: string;
}
interface getChallengeQuestions2 {
  hasError: boolean;
  ErrorDesc: string;
  email: string;
  subscriber: string;
}
interface getChallengeQuestions3 {
  ResponseList: any;
  errorDesc: any;
  hasError: boolean;
  ErrorDesc: string;
  email: string;
  subscriber: string;
  accountType: string;
  accountSubType: string;
}
interface paperless {
  HasError: boolean;
  ErrorDesc: string;
}
interface permissions {
  permission: object;
  idUserAPP: string;
  idParent: string;
  hasError: boolean;
  errorDesc: string;
}
interface userList {
  permission: object;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface rolesList {
  permission: object;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface idRoleList {
  permission: object;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface updateRoles {
  listRoles: object;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface createUser {
  hasError: boolean;
  errorDesc: string;
}
interface getPersonalData {
  HasError: boolean;
  ErrorDesc: string;
  BusinessName: string;
  CelularPhone: string;
  Email: string;
}
interface updatePersonalData {
  HasError: boolean;
  ErrorDesc: string;
  Email: string;
}
interface updatePersonalDir {
  HasError: boolean;
  ErrorDesc: string;
  Email: string;
}
interface getHistoricoFacturas {
  HasError: boolean;
  ErrorDesc: string;
}
interface getHistoricoFacturasNew {
  HasError: boolean;
  ErrorDesc: string;
  ErrorType: string;
  paimentid: string;
  Invoices: string;
}
interface getHistoricalInvoiceOnDemand {
  hasError: boolean;
  ErrorDesc: string;
  binaryData: string;
}
interface getPaymentHistory {
  HasError: boolean;
  ErrorDesc: string;
}
interface changeUser {
  HasError: boolean;
  hasError: boolean;
  ErrorDesc: string;
  errorDesc: string;
  errorDisplay: string;
}
interface changePassword {
  HasError: boolean;
  hasError: boolean;
  ErrorDesc: string;
  errorDesc: string;
  errorDisplay: string;
}
interface getPasswordRecoveryBySubscriber {
  response: any;
  HasError: boolean;
  hasError: boolean;
  ErrorDesc: string;
  errorDesc: string;
  errorDisplay: string;
}
interface validateSubscriber {
  HasError: boolean;
  hasError: boolean;
  ErrorDesc: string;
  errorDesc: string;
  accountType: string;
  accountSubType: string;
  errorDisplay: string;
}
interface getVerifyEmail {
  HasError: boolean;
  hasErrorField: boolean;
  ErrorDesc: string;
  errorDescField: string;
  errorDesc: string;
}
interface setchallengequestions {
  HasError: boolean;
  hasError: boolean;
  ErrorDesc: string;
  errorDesc: string;
}
interface validateSSNAndEmail {
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
}
interface validatePassword {
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
}
interface setPasswordUpdate {
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
  response: string;
}
interface updMessageStatus {
  ErrorDesc: string;
  HasError: boolean;
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
  response: string;
}
interface getpasswordrecovery {
  token: string;
  newpassword: string;
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
  response: string;
}

interface lastInvoice {
  hasError: boolean;
  errorDisplay: string;
}
interface downloadLastPdf {
  UrlPDF: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface deleteAccount {
  hasError: boolean;
  errorDisplay: string;
}
interface getDirectDebitInfo {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface updateDirectDebit {
  data: any;
  data2: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface getReferrals {
  hasError: boolean;
  errorDisplay: string;
  CreditAsReferer: any;
  CreditItems: any[];
}
interface suscribirNeflix {
  hasErrorField: boolean;
  urlField: any;
  errorDescField: any;
  accounts: any;
  data: any;
  data2: any;
  HasError: boolean;
  hasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface optionNeflix {
  hasError: boolean;
  errorDesc: string;
  errorDisplay: string;
  subscriber: string;
  mainSubscriber: string;
  email: string;
}
interface GetSubscriber {
  AccountSubType: any;
  AccountType: any;
  AccountName: string;
  Account: string;
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface warrantyStatus {
  statusDescription: any;
  warrantyReclamationDate: any;
}
interface AddGift1GB {
  Gift1GBIDTransact: any;
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface getChangeMobilePlan {
  data: any;
  hasError: boolean;
  ErrorDesc: string;
}
interface getChangeFixedPlan {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
}
interface activarPlanNow {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
}
interface activarPlanNext {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
}
interface adaDslPackageChange {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  orderNumber: any;
  responseCode: any;
}
interface validateCreditLimit {
  paymentid: string;
  AvailableCredit: any;
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface giftRecharge {
  Gift1GBIDTransact: any;
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface payment {
  IVULottoHostAuthorizationCode: any;
  paymentid: any;
  ETReference_Id: any;
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  mType: any;
}
interface buySVA {
  object: any;
  ErrorDesc: any;
  HasError: boolean;
  hasError: boolean;
  errorDisplay: string;
}
interface applyDiscount {
  ErrorDesc: any;
  hasError: boolean;
  errorDisplay: string;
}
interface getOffersGrupo {
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface getOffers {
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface getReadSubscriber {
  data: any;
  Offers: any;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface addOffersToGroup {
  Description: number;
  ResultCode: any;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface addOffersToSubscriber {
  Description: number;
  ResultCode: any;
  Offers: any;
  hasError: boolean;
  errorDesc: string;
  HasError: boolean;
  ErrorDesc: string;
}
interface subscriptionAutomaticRenewalAdd {
  HasError: boolean;
  ErrorDesc: string;
  Description: string;
}
interface subscriptionAutomaticRenewalRemove {
  HasError: boolean;
  ErrorDesc: string;
  Description: string;
}
interface getTransacts {
  HasError: boolean;
  ErrorDesc: string;
  Subscribers: object;
}
interface sharedCupons {
  data: any;
  hasError: boolean;
  ErrorDesc: string;
  errorDisplay: string;
}
interface getMember {
  data: any;
  hasError: boolean;
  errorDisplay: string;
  memberID: any;
}
interface getValidateReferrer {
  data: any;
  hasError: boolean;
  ErrorDesc: string;
  errorDisplay: string;
  Balance: any;
}
interface getCreditsByAccount {
  data: any;
  HasError: boolean;
  errorDisplay: string;
}
interface getSharingMediaByUser {
  data: any;
  hasError: boolean;
  errorDisplay: string;
}
interface getReferrAccountsAllStatus {
  data: any;
  hasError: boolean;
  errorDisplay: string;
  objItems: any[];
}
interface getGift1GBSend {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
  Gift1GBsents: any[];
}
interface updateToken {
  response: any;
  data: any;
  hasError: boolean;
  errorDisplay: string;
}
interface paymentMethod {
  formPaymentTypes: any;
  success: boolean;
  error: string;
}
interface paymentAddress {
  address: any;
  success: boolean;
  error: string;
}
interface rechargeList {
  formProducts: any;
  success: boolean;
  error: string;
}
interface GetGift1GBByGUI {
  data: any;
  HasError: boolean;
  ErrorDesc: string;
}

interface getPrepaidInfo {
  replenishListItemsField: any;
  hasErrorField: boolean;
  errorDescField: string;
}
interface getChangePlanPrepaid {
  data: any;
  success: boolean;
  hasError: boolean;
  socList: any[];
}
interface updateChangePlanPrepaid {
  data: any;
  success: boolean;
  hasError: boolean;
  desc: string;
}
interface sendFailure {
  desc: String;
  hasError: boolean;
}
interface payRechargeAth {
  error(error: any);
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
}
interface payRecharge {
  idTransaction: string;
  error: any;
  success: boolean;
  desc: String;
  hasError: boolean;
}
interface sendRecharge {
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
}
interface getHobbies {
  data: any;
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
  hobbiesList: any[];
  hobbie: any;
}
interface addMenber {
  data: any;
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
  errorDisplay: string;
  memberID: string;
}
interface addOffersToSubscriberDIARIO10 {
  data: any;
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
  errorDisplay: string;
  ErrorDesc: string;
}
interface newPayment {
  errorDescription: any;
  errorNum: any;
  paymentOptions: any;
}
interface applyPayment {
  errorDescription: string;
  paymentToken: string;
  errorNum: number;
  redirectURL: string;
  hasError: boolean;
}
interface verifyPaymentStatus {
  authorizationNumber: string;
  provisioningReference: string;
  errorDescription: string;
  errorDisplay: string;
  processEndState: boolean;
  hasError: boolean;
  errorNum: number;
  totalAmount: number;
  paymentStatus: string;
}
interface CheckIfTicketExists {
  result: any[];
  hasError: boolean;
  errorDesc: any;
}
interface RaiseIssueTicket {
  result: any[];
  hasError: boolean;
  errorDesc: any;
}
interface botchat {
  hasError: boolean;
  message: any;
  url: any;
  errorDisplay: any;
  errorDesc: any;
}
interface updateRegister {
  data: any;
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
  errorDisplay: string;
  accountSubType: any;
  errorNum: number;
  account: string;
  accounts: object;
  accountType: string;
  email: string;
  idParent: string;
  name: string;
  errorDesc: string;
  token: string;
  subscriber: string;
  username: string;
  requiredEmailUpdate: boolean;
  requiredPaperless: boolean;
  requiredQuestions: boolean;
  requiredAccountUpdate: boolean;
  requiredPasswordReset: boolean;
}
interface validateSubscriberUpdate {
  data: any;
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String;
  hasError: boolean;
  errorDisplay: string;
  productType: any;
}
interface getInstallments {
  errorDescription: any;
  errorDisplay: any;
  errorNum: number;
  errorSubject: any;
  hasError: boolean;
  message: any;
  AmountToAccelerate: number;
  accountNumber: any;
  originalInstallmentAmount: number;
  originalInstallmentQty: number;
  productType: any;
  quantityToAccelerate: number;
  queryType: any;
  reminderInstallmentAmount: number;
  reminderInstallmentQty: number;
  subscriberNumber: any;
  valueRequested: number;
}
interface listCatalogue {
  catalogs: any;
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: any;
}
interface bannersList {
  banner: string;
  id: number;
  link: string;
  order: number;
  status: boolean;
  type: number;
  url: string;
}
interface channels {
  name: string;
  url: string;
  status: boolean;
}
interface addTocart {
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
}
interface cart {
  allowRecovery: boolean;
  creditClass: string;
  delicuency: boolean;
  depositAmount: number;
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
  installmentAmount: number;
  products: any;
  promoCode: string;
  promoCodeDiscountAmount: number;
  promoCodePromotionType: string;
  taxes: any;
  token: string;
  totalBaseTax: number;
  totalDownPayment: number;
  totalPerMonth: number;
  totalPrice: number;
  totalRegular: number;
  totalTax: number;
}
interface plans {
  catalogId: number;
  catalogName: string;
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
  plans: object;
  productId: number;
}
interface equipment {
  colors: object;
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
  productId: number;
  productName: string;
  ralatedAccesories: object;
}
interface createAddress {
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: false;
}
interface productsIPTV {
  accesory: boolean;
  catalogID: number;
  catalogName: string;
  chvMerchantCode: string;
  colors: object;
  equipment: boolean;
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
  imei: boolean;
  iptv: boolean;
  iptvContracts: object;
  parentCatalog: number;
  plan: boolean;
  postpaid: boolean;
  prepaid: boolean;
  productId: number;
  productName: string;
  sim: boolean;
  sva: boolean;
  txtDescription: string;
}
interface addToCartIPTV {
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
}
interface loginTokenSSO {
  errorDesc: string;
  errorDisplay: string;
  errorNum: number;
  errorSubject: string;
  hasError: boolean;
  intUserId: number;
  message: string;
  response: any;
}
export interface proccessOrder {
  address: string;
  ban: string;
  cartInfo: any;
  createdDate: string;
  email: string;
  errorDesc: string;
  errorInter: string;
  errorNum: number;
  hasError: boolean;
  name: string;
  order: number;
  paymentInfo: any;
  subscriber: string;
}
@Injectable({
  providedIn: "root",
})
export class Service {
  public externalLoginPath = sessionStorage.getItem("externalLoginPath");
  private urlService: string = "/api";
  constructor(private http: HttpClient, private router: Router) {}
  downloadFile(token: string, fileName: string) {
    var form = new FormData();
    form.append("token", token);
    form.append("fileName", fileName);
    return this.http.post<Blob>(
      this.urlService + "/Authenticate/downloadFile",
      form,
      { responseType: "blob" as "json" }
    );
    //return this.http.post<proccessOrder>(this.urlService + '/Authenticate/downloadFile', form);
  }
  proccessOrderIptv(token: string, tokenShop: string) {
    var form = new FormData();
    form.append("token", token);
    form.append("tokenShop", tokenShop);
    return this.http.post<proccessOrder>(
      this.urlService + "/Authenticate/proccessOrderIptv",
      form
    );
  }
  paymentIPTV(
    tokenShop: string,
    flowId: number,
    name: string,
    numberCard: string,
    cvv: string,
    typeCard: string,
    expMonth: string,
    expYear: string,
    amount: number,
    email: string,
    account: any,
    subscriber: string,
    zipCodeCard: string,
    deposit: number
  ) {
    var form = new FormData();
    form.append("tokenShop", tokenShop);
    form.append("token", sessionStorage.getItem("token"));
    form.append("flowId", flowId.toString());
    form.append("name", name);
    form.append("numberCard", numberCard);
    form.append("cvv", cvv);
    form.append("typeCard", typeCard);
    form.append("expMonth", expMonth);
    form.append("expYear", expYear);
    form.append("account", account);
    form.append("subscriber", subscriber);
    form.append("amount", amount.toString());
    form.append("email", email);
    form.append("zipCode", zipCodeCard);
    form.append("deposit", deposit.toString());
    //payment
    return this.http.post<plans>(
      this.urlService + "/Authenticate/payment2",
      form
    );
  }
  loginTokenSSO(ssoToken: string, tokenShop: string) {
    var form = new FormData();
    form.append("token", tokenShop);
    form.append("ssoToken", ssoToken);
    return this.http.post<loginTokenSSO>(
      this.urlService + "/Authenticate/loginTokenSSO",
      form
    );
  }
  getToken() {
    var form = new FormData();
    return this.http.post<token>(
      this.urlService + "/Authenticate/getToken",
      form
    );
  }
  addToCartIPTV(
    tokenShop: string,
    bitContract: boolean,
    intContractTermsInMonths: number,
    qty: number,
    intInstallments: number,
    flowId: string
  ) {
    var form = new FormData();
    form.append("tokenShop", tokenShop);
    form.append("token", sessionStorage.getItem("token"));
    form.append("bitContract", bitContract.toString());
    form.append("intInstallments", intInstallments.toString());
    form.append(
      "intContractTermsInMonths",
      intContractTermsInMonths.toString()
    );
    form.append("qty", qty.toString());
    form.append("flowId", flowId);
    return this.http.post<addToCartIPTV>(
      this.urlService + "/Authenticate/addToCartIPTV",
      form
    );
  }
  productsIPTV(tokenShop: string) {
    var form = new FormData();
    form.append("tokenShop", tokenShop);
    form.append("token", sessionStorage.getItem("token"));
    return this.http.post<productsIPTV>(
      this.urlService + "/Authenticate/productsIPTV ",
      form
    );
  }
  getTemplete(path: string) {
    return this.http.get(path, { responseType: "text" });
  }
  createAddress(
    tokenShop: string,
    name: string,
    email: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zip: string,
    notes: string,
    phone: string,
    intUserId: number
  ) {
    var form = new FormData();
    form.append("token", sessionStorage.getItem("token"));
    form.append("tokenShop", tokenShop);
    form.append("name", name);
    form.append("email", email);
    form.append("address1", address1);
    form.append("address2", address2);
    form.append("city", city);
    form.append("state", state);
    form.append("zip", zip);
    form.append("notes", notes);
    form.append("phone", phone);
    form.append("intUserId", intUserId.toString());
    return this.http.post<createAddress>(
      this.urlService + "/Authenticate/createAddress",
      form
    );
  }
  getConfig() {
    return this.http.get("/assets/config.json");
  }

  getProvisional() {
    return this.http.get("/assets/config.json");
  }

  getIframedata() {
    return this.http.get("/assets/local-data/iframedata.json");
  }
  validateIptv2Account(email: string, tokenShop: string) {
    var form = new FormData();
    form.append("token", sessionStorage.getItem("token"));
    form.append("tokenShop", tokenShop);
    form.append("email", email);
    return this.http.post<plans>(
      this.urlService + "/Authenticate/validateIptv2Account",
      form
    );
  }
  equipmentDetail(productId: number, tokenShop: string) {
    var form = new FormData();
    form.append("productId", this.securityFilter(productId.toString()));
    form.append("tokenShop", tokenShop);
    return this.http.post<equipment>(
      this.urlService + "/Authenticate/equipmentDetail",
      form
    );
  }
  securityFilter(value) {
    let patron = / AND /gi;
    value = value.toString().replace(patron, " ");
    patron = / OR /gi;
    value = value.toString().replace(patron, " ");
    patron = /  AND  /gi;
    value = value.toString().replace(patron, " ");
    patron = /  OR  /gi;
    value = value.toString().replace(patron, " ");
    return value;
  }
  addOnsPromo(productId: number, tokenShop: string) {
    var form = new FormData();
    form.append("token", sessionStorage.getItem("token"));
    form.append("tokenShop", tokenShop);
    form.append("productId", productId.toString());
    return this.http.post<plans>(
      this.urlService + "/Authenticate/addOnsPromo",
      form
    );
  }
  deleteItem(cartId: number, productId: number, tokenShop: string) {
    var form = new FormData();
    form.append("token", sessionStorage.getItem("token"));
    form.append("cartId", cartId.toString());
    form.append("productId", productId.toString());
    form.append("tokenShop", tokenShop);
    return this.http.post<plans>(
      this.urlService + "/Authenticate/deleteItem",
      form
    );
  }
  plansIPTV(productId: string, tokenShop: string) {
    var form = new FormData();
    form.append("productId", productId);
    form.append("token", sessionStorage.getItem("token"));
    form.append("tokenShop", tokenShop);
    return this.http.post<addTocart>(
      this.urlService + "/Authenticate/plansIPTV ",
      form
    );
  }
  getCart(tokenShop: string) {
    var form = new FormData();
    form.append("token", sessionStorage.getItem("token"));
    form.append("tokenShop", tokenShop);
    return this.http.post<cart>(
      this.urlService + "/Authenticate/getCart",
      form
    );
  }
  addToCart(cartItems: string, token: string) {
    var form = new FormData();
    form.append("cartItems", cartItems);
    form.append("token", token);
    return this.http.post<addTocart>(
      this.urlService + "/Authenticate/addToCart ",
      form
    );
  }
  channelsFull(token: string) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<channels>(
      this.urlService + "/Authenticate/channelsFull",
      form
    );
  }
  channelsList(token: string, idPlan: number, idAddOn: number, top: number) {
    var form = new FormData();
    form.append("token", token);
    form.append("idPlan", idPlan.toString());
    form.append("idAddOn", idAddOn.toString());
    form.append("top", top.toString());
    return this.http.post<bannersList>(
      this.urlService + "/Authenticate/channelsList",
      form
    );
  }
  listCatalogue(
    token: string,
    catalogId: number,
    pageNo: number,
    pageItems: number,
    brand: string,
    offers: string,
    creditClass: string,
    categoryID: number,
    newProduct: string,
    orderBy: string
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("catalogId", "11");
    form.append("pageNo", "1");
    form.append("pageItems", "100");
    form.append("creditClass", "C");
    form.append("categoryID", "0");
    form.append("brand", "");
    form.append("orderBy", "ASC");
    form.append("new", "0");
    form.append("offers", "0");
    return this.http.post<listCatalogue>(
      this.urlService + "/Authenticate/listCatalogue",
      form
    );
  }

  loginExternal(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<login>(
      this.urlService + "/Authenticate/loginExternal",
      form
    );
  }

  validateSubscriberUpdate(subscriber, token) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("token", token);
    return this.http.post<validateSubscriberUpdate>(
      this.urlService + "/Authenticate/validateSubscriberUpdate",
      form
    );
  }
  updateRegister(subscriber, code, ssn, token) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("code", code);
    form.append("ssn", ssn);
    form.append("token", token);
    return this.http.post<updateRegister>(
      this.urlService + "/Authenticate/updAccountValidateCode",
      form
    );
  }

  botchat(
    token,
    tokenSSO,
    region,
    category,
    id,
    origin,
    customerName,
    accountNumber,
    email,
    appType,
    cedula
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("tokenSSO", tokenSSO);
    form.append("region", region);

    // form.append("category", "501");
    form.append("category", category);
    form.append("id", "e2f7386f-32d3-44ed-8088-0133d1191124"); //pasado del lado del servicio
    form.append("origin", origin);
    //form.append("origin", "11");

    form.append("customerName", customerName);
    form.append("accountNumber", accountNumber);
    form.append("email", email);
    form.append("appType", appType);
    form.append("cedula", cedula);
    return this.http.post<botchat>(
      this.urlService + "/Authenticate/botchat",
      form
    );
  }

  CheckIfTicketExists(telNum) {
    var form = new FormData();
    form.append("telNum", telNum);
    return this.http.post<CheckIfTicketExists>(
      this.urlService + "/Authenticate/CheckIfTicketExists",
      form
    );
  }

  RaiseIssueTicket(
    SubscriberNumber,
    Ban,
    ContactNumber1,
    ContactNumber2,
    OutageType,
    OperatorID,
    CustomerReport,
    Remark,
    ProductType
  ) {
    var form = new FormData();
    form.append("SubscriberNumber", SubscriberNumber);
    form.append("Ban", Ban);
    form.append("ContactNumber1", ContactNumber1);
    form.append("ContactNumber2", ContactNumber2);
    form.append("OutageType", OutageType);
    form.append("OperatorID", OperatorID);
    form.append("CustomerReport", CustomerReport);
    form.append("Remark", Remark);
    form.append("ProductType", ProductType);
    return this.http.post<RaiseIssueTicket>(
      this.urlService + "/Authenticate/RaiseIssueTicket",
      form
    );
  }
  addOffersToSubscriberDIARIO10(
    token,
    OldSocCode,
    mSocCode,
    mProductType,
    mSubscriberNo,
    BAN,
    CommitmentStartDate,
    ExpirationDate,
    EffectiveDate,
    RelatedSocCode
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("OldSocCode", OldSocCode);
    form.append("mSocCode", mSocCode);
    form.append("mProductType", mProductType);
    form.append("mSubscriberNo", mSubscriberNo);
    form.append("BAN", BAN);
    form.append("CommitmentStartDate", CommitmentStartDate);
    form.append("ExpirationDate", ExpirationDate);
    form.append("EffectiveDate", EffectiveDate);
    form.append("RelatedSocCode", RelatedSocCode);
    return this.http.post<addOffersToSubscriberDIARIO10>(
      this.urlService + "/Authenticate/updateSubscriberPricePlanSocsDIARIO10",
      form
    );
  }

  addMenber(
    campaingID,
    accountName,
    subscriber,
    account,
    accountType,
    accountSubType,
    productType,
    source,
    dob,
    hobby,
    email,
    paperless,
    token
  ) {
    var form = new FormData();
    form.append("campaingID", campaingID);
    form.append("accountName", accountName);
    form.append("subscriber", subscriber);
    form.append("account", account);
    form.append("accountType", accountType);
    form.append("accountSubType", accountSubType);
    form.append("productType", productType);
    form.append("source", source);
    form.append("dob", dob);
    form.append("hobby", hobby);
    form.append("email", email);
    form.append("paperless", paperless);
    form.append("token", token);
    return this.http.post<addMenber>(
      this.urlService + "/Authenticate/addmember",
      form
    );
  }
  getHobbies(token, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    return this.http.post<getHobbies>(
      this.urlService + "/Authenticate/gethobbies",
      form
    );
  }

  addSubscriber(token, phoneNumber) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", phoneNumber);
    return this.http.post<sendRecharge>(
      this.urlService + "/Authenticate/addSubscriber",
      form
    );
  }
  codeValidate(token, code) {
    var form = new FormData();
    form.append("token", token);
    form.append("code", code);
    return this.http.post<sendRecharge>(
      this.urlService + "/Authenticate/codeValidate",
      form
    );
  }
  validatePrepaid(suscriptor, pin) {
    var form = new FormData();
    form.append("phone", suscriptor);
    form.append("password", pin);
    return this.http.post<sendRecharge>(
      this.urlService + "/Authenticate/validatePrepaidAccount",
      form
    );
  }
  resendCode(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<sendRecharge>(
      this.urlService + "/Authenticate/resendCode",
      form
    );
  }
  sendRecharge(token, idProduct, amount, idCustomerCard, subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("suscriber", subscriber);
    form.append("idCustomerCard", idCustomerCard);
    form.append("idProduct", idProduct);
    form.append("amount", amount);
    return this.http.post<sendRecharge>(
      this.urlService + "/Authenticate/sendRecharge",
      form
    );
  }
  payRecharge(
    token,
    address,
    zipcode,
    totalPagar,
    NameOnCard,
    idNroTejeta,
    suscriber,
    mes,
    anio,
    cvNum,
    idProduct,
    idTarjeta,
    idCustomerCard
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", suscriber);
    form.append("address", address);
    form.append("amount", totalPagar);
    form.append("city", "");
    form.append("cvv", cvNum);
    form.append("idCustomerCard", idCustomerCard);
    form.append("idPaymentType", idTarjeta);
    form.append("idProduct", idProduct);
    form.append("idState", "4240"); //PR
    form.append("month", mes);
    form.append("name", NameOnCard);
    form.append("number", idNroTejeta);
    form.append("suscriber", suscriber);
    form.append("year", anio);
    form.append("zip", zipcode);
    return this.http.post<payRechargeAth>(
      this.urlService + "/Authenticate/prepaidPayment",
      form
    );
  }
  payRechargeAth(
    token,
    address,
    zipcode,
    totalPagar,
    NameOnCard,
    idNroTejeta,
    suscriber,
    mes,
    anio,
    cvNum,
    idProduct,
    idTarjeta,
    idCustomerCard
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("amount", totalPagar);
    form.append("idCustomerCard", idCustomerCard);
    form.append("idPaymentType", idTarjeta);
    form.append("idProduct", idProduct);
    form.append("month", mes);
    form.append("name", NameOnCard);
    form.append("number", idNroTejeta);
    form.append("suscriber", suscriber);
    form.append("year", anio);
    return this.http.post<payRecharge>(
      this.urlService + "/Authenticate/prepaidPaymentATH",
      form
    );
  }
  sendFailure(
    token,
    accountNumber,
    accountType,
    accountSubType,
    subscriber,
    failureType,
    failureDetail,
    description,
    contactNumber1,
    contactNumber2
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("accountNumber", accountNumber);
    form.append("accountType", accountType);
    form.append("accountSubType", accountSubType);
    form.append("subscriber", subscriber);
    form.append("productType", "O");
    form.append(
      "message",
      failureType + "|" + failureDetail + "|" + description
    );
    form.append("contactNumber1", contactNumber1);
    form.append("contactNumber2", contactNumber2);
    return this.http.post<sendFailure>(
      this.urlService + "/Authenticate/sendFailure",
      form
    );
  }
  getPrepaidInfo(suscriber, token) {
    var form = new FormData();
    form.append("suscriber", suscriber);
    form.append("token", token);
    return this.http.post<getPrepaidInfo>(
      this.urlService + "/Authenticate/getPrepaidInfo",
      form
    );
  }
  rechargeList(token, subscriber, idProductType) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    form.append("idProductType", idProductType);
    return this.http.post<rechargeList>(
      this.urlService + "/Authenticate/rechargeList",
      form
    );
  }
  paymentAddress(token, subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    return this.http.post<paymentAddress>(
      this.urlService + "/Authenticate/paymentAddress",
      form
    );
  }
  paymentMethod(token, subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    return this.http.post<paymentMethod>(
      this.urlService + "/Authenticate/paymentMethod",
      form
    );
  }
  updateToken(token, account, subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    form.append("subscriber", subscriber);
    return this.http.post<updateToken>(
      this.urlService + "/Authenticate/updateToken",
      form
    );
  }
  getTransacts(Ban, token) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    return this.http.post<getTransacts>(
      this.urlService + "/Authenticate/accountPackagesInfo",
      form
    );
  }
  subscriptionAutomaticRenewalAdd(SubscriberId, OfferID, BaseOfferId, token) {
    var form = new FormData();
    form.append("token", token);
    form.append("SubscriberId", SubscriberId);
    form.append("OfferID", OfferID);
    form.append("BaseOfferId", BaseOfferId);
    return this.http.post<subscriptionAutomaticRenewalAdd>(
      this.urlService + "/Authenticate/subscriptionAutomaticRenewalAdd",
      form
    );
  }
  subscriptionAutomaticRenewalRemove(
    SubscriberId,
    OfferID,
    BaseOfferId,
    token
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("SubscriberId", SubscriberId);
    form.append("OfferID", OfferID);
    form.append("BaseOfferId", BaseOfferId);
    return this.http.post<subscriptionAutomaticRenewalRemove>(
      this.urlService + "/Authenticate/subscriptionAutomaticRenewalRemove",
      form
    );
  }
  applyDiscount(token, account, subscriber, amount) {
    var form = new FormData();
    form.append("strcomentario", "dashboard");
    form.append("token", token);
    form.append("account", account);
    form.append("subscriber", subscriber);
    form.append("total", amount);
    form.append("applyDiscountID", "1");
    return this.http.post<applyDiscount>(
      this.urlService + "/Authenticate/applyDiscount",
      form
    );
  }
  activarPlanNow(token, currentSoc, nextSoc, typeActual, subscriberNumber) {
    var form = new FormData();
    form.append("token", token);
    form.append("OldSocCode", currentSoc);
    form.append("NewSocCode", nextSoc);
    form.append("mProductType", typeActual);
    form.append("mSubscriberNo", subscriberNumber);
    return this.http.post<activarPlanNow>(
      this.urlService + "/Authenticate/updateSubscriberPricePlanSocs",
      form
    );
  }
  activarPlanNext(
    token,
    currentSoc,
    nextSoc,
    typeActual,
    subscriberNumber,
    BAN
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("OldSocCode", currentSoc);
    form.append("NewSocCode", nextSoc);
    form.append("mProductType", typeActual);
    form.append("mSubscriberNo", subscriberNumber);
    form.append("BAN", BAN);
    return this.http.post<activarPlanNext>(
      this.urlService + "/Authenticate/updateSubscriberPricePlanSocsNextCicle",
      form
    );
  }
  adaDslPackageChange(
    token,
    contractMonthsTxt,
    contract,
    subscriberNumber,
    nextSoc,
    ban,
    rectaActual,
    ProductType
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("alphaCodeContract", contractMonthsTxt);
    form.append("contract", contract);
    form.append("oldSocPrice", rectaActual);
    form.append("dslPhoneNumber", subscriberNumber);
    form.append("dslBan", ban);
    form.append("productId", nextSoc);
    form.append("ProductType", ProductType);
    return this.http.post<adaDslPackageChange>(
      this.urlService + "/Authenticate/adaDslPackageChange",
      form
    );
  }
  sharedCupons(token, memberID, userLink, emails) {
    var form = new FormData();
    form.append("memberID", memberID);
    form.append("token", token);
    form.append("link", userLink);
    form.append("email", emails);
    return this.http.post<sharedCupons>(
      this.urlService + "/Authenticate/sharedCupons",
      form
    );
  }
  getMember(token, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    return this.http.post<getMember>(
      this.urlService + "/Authenticate/getMember",
      form
    );
  }
  getValidateReferrer(token, suscriber, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", suscriber);
    form.append("account", account);
    return this.http.post<getValidateReferrer>(
      this.urlService + "/Authenticate/getValidateReferrer",
      form
    );
  }
  getChangeFixedPlan(token, phoneNumber) {
    var form = new FormData();
    form.append("token", token);
    form.append("phoneNumber", phoneNumber);
    return this.http.post<getChangeFixedPlan>(
      this.urlService + "/Authenticate/DSLCatalog",
      form
    );
  }
  getChangeMobilePlan(
    token,
    CreditClass,
    mSocCode,
    PlanRate,
    tech,
    AccountType,
    AccountSubType
  ) {
    let mSocCode2 = "";
    if (mSocCode != null) {
      mSocCode2 = mSocCode.replace("'", "");
      mSocCode2 = mSocCode2.replace("'", "");
    } else {
      mSocCode2 = "";
    }
    var AccountType2 = AccountType.replace("'", "");
    var form = new FormData();
    form.append("creditClass", CreditClass);
    form.append("customerSubType", AccountSubType);
    form.append("customerType", AccountType2);
    form.append("price", PlanRate);
    form.append("soc", mSocCode2);
    form.append("tecnology", tech);
    form.append("token", token);
    return this.http.post<getChangeMobilePlan>(
      this.urlService + "/Authenticate/getChangeMobilePlan",
      form
    );
  }
  getCreditsByAccount(token, Account) {
    var form = new FormData();
    form.append("token", token);
    form.append("Account", Account);
    return this.http.post<getCreditsByAccount>(
      this.urlService + "/Authenticate/getCreditsByAccount",
      form
    );
  }
  getChangePlanPrepaid(
    creditClass,
    customerType,
    customerSubType,
    price,
    tecnology,
    soc,
    productType,
    token
  ) {
    var form = new FormData();
    form.append("creditClass", creditClass);
    form.append("customerSubType", customerSubType);
    form.append("customerType", customerType);
    form.append("price", price);
    form.append("soc", soc);
    form.append("tecnology", tecnology);
    form.append("productType", productType);
    form.append("token", token);
    return this.http.post<getChangePlanPrepaid>(
      this.urlService + "/Authenticate/getChangePlanPrepaid",
      form
    );
  }
  updateChangePlanPrepaid(
    accountType,
    accountSubType,
    effectiveDate,
    oldSocCode,
    socCode,
    productType,
    socId,
    token,
    subscriber
  ) {
    var form = new FormData();
    form.append("accountSubType", accountSubType);
    form.append("accountType", accountType);
    form.append("effectiveDate", effectiveDate);
    form.append("oldSocCode", oldSocCode);
    form.append("socCode", socCode);
    form.append("productType", productType);
    form.append("socId", socId);
    form.append("token", token);
    form.append("subscriber", subscriber);
    return this.http.post<any>(
      this.urlService + "/Authenticate/updateChangePlanPrepaid",
      form
    );
  }
  warrantyStatus(subscriber) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    return this.http.post<warrantyStatus>(
      this.urlService + "/Authenticate/warrantyStatus",
      form
    );
  }
  getSharingMediaByUser(token, memberID, campaignID) {
    var form = new FormData();
    form.append("token", token);
    form.append("memberID", memberID);
    form.append("campaignID", campaignID);
    return this.http.post<getSharingMediaByUser>(
      this.urlService + "/Authenticate/getSharingMediaByUser",
      form
    );
  }
  getReferrAccountsAllStatus(token, campaignID, Account, Subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("campaignID", campaignID);
    form.append("Account", Account);
    form.append("Subscriber", Subscriber);
    return this.http.post<getReferrAccountsAllStatus>(
      this.urlService + "/Authenticate/getReferrAccountsAllStatus",
      form
    );
  }
  getPrueba(url) {
    return this.http.get<getGift1GBSend>(url);
  }
  getGift1GBSend(token, BAN) {
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    return this.http.post<getGift1GBSend>(
      this.urlService + "/Authenticate/getGift1GBSend",
      form
    );
  }
  GetGift1GBByGUI(GUI) {
    var form = new FormData();
    form.append("GUI", GUI);
    return this.http.post<GetGift1GBByGUI>(
      this.urlService + "/Authenticate/acceptGBByGUI",
      form
    );
  }
  login(Username, Password) {
    var form = new FormData();
    form.append("Username", Username);
    form.append("Password", Password);
    return this.http.post<login>(this.urlService + "/Authenticate/Login", form);
  }
  addOffersToGroup(
    SubscriberId,
    Cicle,
    OfferId,
    GroupId,
    paymentID,
    Charge,
    token,
    UserID
  ) {
    var form = new FormData();
    form.append("TransactionId", btoa("123456"));
    form.append("RequesterId", btoa("1" + SubscriberId));
    form.append("OfferId", btoa(OfferId));
    form.append("Charge", btoa(Charge));
    form.append("Cicle", btoa(Cicle));
    form.append("paymentID", btoa(paymentID));
    form.append("GroupId", btoa(GroupId));
    form.append("UserID", btoa(UserID));
    form.append("token", token);
    return this.http.post<addOffersToGroup>(
      this.urlService + "/Authenticate/addOffersToGroup",
      form
    );
  }
  addOffersToSubscriber(
    SubscriberId,
    Cicle,
    OfferId,
    paymentID,
    Charge,
    token,
    UserID
  ) {
    if (paymentID == "" || paymentID == null || paymentID == undefined) {
      paymentID = "";
    } else {
      paymentID = btoa(paymentID);
    }
    var form = new FormData();
    form.append("TransactionId", btoa("123456"));
    form.append("SubscriberId", btoa("1" + SubscriberId));
    form.append("OfferId", btoa(OfferId));
    form.append("Charge", btoa(Charge));
    form.append("Cicle", btoa(Cicle));
    form.append("paymentID", paymentID);
    form.append("UserID", btoa(UserID));
    form.append("token", token);
    return this.http.post<addOffersToSubscriber>(
      this.urlService + "/Authenticate/addOffersToSubscriber",
      form
    );
  }
  getReadSubscriber(telf) {
    var form = new FormData();
    form.append("TransactionId", "123456");
    form.append("IdSubscriber", telf);
    return this.http.post<getReadSubscriber>(
      this.urlService + "/Authenticate/getReadSubscriber",
      form
    );
  }
  getOffersGrupo(OfferGroup, SubscriberId, TransactionId) {
    var form = new FormData();
    form.append("OfferGroup", OfferGroup);
    form.append("SubscriberId", SubscriberId);
    form.append("TransactionId", TransactionId);
    return this.http.post<getOffersGrupo>(
      this.urlService + "/Authenticate/GetOffersToSubscriberFromOfferGroup",
      form
    );
  }
  buySVA(
    token,
    soc,
    accountFrom,
    subscriberFrom,
    channel,
    invoiceCharge,
    amount
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("soc", soc);
    form.append("accountFrom", accountFrom);
    form.append("subscriberFrom", subscriberFrom);
    form.append("channel", channel);
    form.append("invoiceCharge", invoiceCharge);
    form.append("amount", amount);
    return this.http.post<buySVA>(
      this.urlService + "/Authenticate/buySVA",
      form
    );
  }

  newPayment(productId, offerId) {
    var form = new FormData();
    form.append("productId", productId);
    form.append("merchantCodeId", offerId);
    return this.http.post<newPayment>(
      this.urlService + "/Authenticate/newPayment",
      form
    );
  }
  applyPayment(
    offerId,
    productId,
    paymentOptionId,
    paymentAmount,
    customerEmail,
    subscriberNumber,
    subscriberAccountNumber,
    subscriberFullName,
    subscriberAddress1,
    subscriberAddress2,
    subscriberCity,
    subscriberState,
    subscriberZipCode,
    transactionDescription,
    banSend,
    subscribeSend,
    locationId,
    invoiceNumber,
    userId
  ) {
    var form = new FormData();
    const payload = {
      appId: "MICLAROWEB",
      productId,
      merchantCodeId: "",
      paymentOptionId,
      paymentAmount,
      customerEmail,
      subscriberNumber,
      subscriberAccountNumber,
      subscriberFullName,
      subscriberAddress2: subscriberAddress2 ? subscriberAddress2 : ``,
      subscriberAddress1: subscriberAddress1 ? subscriberAddress1 : "",
      subscriberCity,
      subscriberState,
      subscriberZipCode,
      transactionDescription,
      receiverSubsNumber: subscribeSend,
      recieverAcctNumber: banSend,
      locationId,
      invoiceNumber,
      doProvisioning: "1",
      parentPaymentToken: "",
      paymentTokenType: "",
      userId: userId ? userId : "",
      installmentUnits: 0,
      paymentType: "SIMPLE",
      extendedData: "",
    };

    const data = btoa(JSON.stringify(payload));
    form.append("data", data);
    return this.http.post<applyPayment>(
      this.urlService + "/Authenticate/applyPayment",
      form
    );
  }
  verifyPaymentStatus(paymentToken) {
    var form = new FormData();
    form.append("paymentToken", paymentToken);
    return this.http.post<verifyPaymentStatus>(
      this.urlService + "/Authenticate/verifyPaymentStatus",
      form
    );
  }

  voidPayment(paymentToken) {
    var form = new FormData();
    form.append("paymentToken", paymentToken);
    return this.http.post<verifyPaymentStatus>(
      this.urlService + "/Authenticate/voidPayment",
      form
    );
  }

  payment(
    TransType,
    CardNum,
    ExpDate,
    MagData,
    NameOnCard,
    Amount,
    InvNum,
    PNRef,
    Zip,
    Street,
    CVNum,
    ExtData,
    ClientApp,
    CustomerId,
    PayType,
    cellphone,
    state,
    city,
    account,
    description,
    email,
    token
  ) {
    var form = new FormData();
    form.append("TransType", btoa(TransType));
    form.append("CardNum", btoa(CardNum));
    form.append("ExpDate", btoa(ExpDate));
    form.append("MagData", btoa(MagData));
    form.append("NameOnCard", btoa(NameOnCard));
    form.append("Amount", btoa(parseFloat(Amount).toFixed(2)));
    form.append("InvNum", btoa(InvNum));
    form.append("PNRef", btoa(PNRef));
    form.append("Zip", btoa(Zip));
    form.append("Street", btoa(Street));
    form.append("CVNum", btoa(CVNum));
    form.append("ExtData", btoa(ExtData));
    form.append("ClientApp", btoa(ClientApp));
    form.append("CustomerId", btoa(CustomerId));
    form.append("PayType", btoa(PayType));
    form.append("cellphone", btoa(cellphone));
    form.append("state", btoa(state));
    form.append("city", btoa(city));
    form.append("account", btoa(account));
    form.append("description", btoa(description));
    form.append("email", btoa(email));
    form.append("token", token);
    return this.http.post<payment>(
      this.urlService + "/Authenticate/makePayment",
      form
    );
  }
  giftRecharge(
    token,
    accountFrom,
    NameSender,
    accountTo,
    subscriberFrom,
    subscriberTo,
    message,
    PaymentID,
    Charge,
    amount,
    userName
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("accountFrom", accountFrom);
    form.append("accountTo", accountTo);
    form.append("subscriberFrom", subscriberFrom);
    form.append("subscriberTo", subscriberTo);
    form.append("amount", amount);
    form.append("message", message);
    form.append("source", "web");
    form.append("UserName", userName);
    return this.http.post<giftRecharge>(
      this.urlService + "/Authenticate/giftRecharge",
      form
    );
  }
  validateCreditLimit(ban, AccountTotalRent, ProductPrice) {
    var form = new FormData();
    form.append("AccountTotalRent", btoa(AccountTotalRent));
    form.append("ProductPrice", btoa(ProductPrice));
    form.append("Ban", btoa(ban));
    return this.http.post<validateCreditLimit>(
      this.urlService + "/Authenticate/ValidateCreditLimit",
      form
    );
  }

  AddGift1GB(
    token,
    BANSender,
    NameSender,
    BANReceiver,
    SubscriberSender,
    SubscriberReceiver,
    Message,
    PaymentID,
    Charge
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("BANSender", BANSender);
    form.append("NameSender", NameSender);
    form.append("BANReceiver", BANReceiver);
    form.append("SubscriberSender", SubscriberSender);
    form.append("SubscriberReceiver", SubscriberReceiver);
    form.append("Message", Message);
    form.append("Charge", Charge);
    form.append("PaymentID", PaymentID);
    return this.http.post<AddGift1GB>(
      this.urlService + "/Authenticate/AddGift1GB",
      form
    );
  }
  GetSubscriber(token, Subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("Subscriber", Subscriber);
    return this.http.post<GetSubscriber>(
      this.urlService + "/Authenticate/GetSubscriber",
      form
    );
  }
  suscribirNeflix(userAgent, token, account, subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("userAgent", userAgent);
    form.append("account", account);
    form.append("subscriber", subscriber);
    form.append("customerType", "");
    form.append("productId", "");
    form.append("subProductId", "");
    form.append("mpromotionId", "");
    form.append("mdeviceSerialNumber", "");
    form.append("msalesChannel", "");
    form.append("moperatorUrlError", "");
    return this.http.post<suscribirNeflix>(
      this.urlService + "/Authenticate/suscribirNeflix",
      form
    );
  }
  getValidationCodeOptions(token, subscriber) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    return this.http.post<optionNeflix>(
      this.urlService + "/Authenticate/getValidationCodeOptions",
      form
    );
  }
  getValidationCode(token, subscriber, email) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    form.append("email", email);
    return this.http.post<optionNeflix>(
      this.urlService + "/Authenticate/getValidationCode",
      form
    );
  }
  validateCode(token, code) {
    var form = new FormData();
    form.append("token", token);
    form.append("code", code);
    return this.http.post<optionNeflix>(
      this.urlService + "/Authenticate/validateCode",
      form
    );
  }
  updateDirectDebit(
    token,
    type,
    creditCardNo,
    creditCardMemberName,
    creditCardType,
    creditCardExpDate,
    startDate,
    bankAccountNo,
    endDate,
    bankCode,
    accountNumber,
    status
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("Ban", accountNumber);
    form.append("mAccountNo", bankAccountNo);
    form.append("mBankCode", bankCode);
    form.append("mCreditCardExpDate", creditCardExpDate);
    form.append("mCreditCardMemberName", creditCardMemberName);
    form.append("mCreditCardNo", creditCardNo);
    form.append("mCreditCardType", creditCardType);
    form.append("mEndDate", endDate);
    form.append("mStartDate", startDate);
    form.append("mStatus", status);
    form.append("mType", type);
    form.append("mReason", "");
    return this.http.post<updateDirectDebit>(
      this.urlService + "/Authenticate/updateDirectDebit",
      form
    );
  }

  getOffers(OfferGroup, SubscriberId, TransactionId, offerID) {
    var form = new FormData();
    form.append("OfferGroup", OfferGroup);
    form.append("SubscriberId", SubscriberId);
    form.append("TransactionId", TransactionId);
    form.append("offerID", offerID);
    return this.http.post<getOffers>(
      this.urlService + "/Authenticate/getOffers",
      form
    );
  }
  idUserRoleList(idUser) {
    var form = new FormData();
    form.append("idUser", idUser);
    return this.http.post<idRoleList>(
      this.urlService + "/Authenticate/idUserRoleList",
      form
    );
  }
  getDirectDebitInfo(token, BAN) {
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    return this.http.post<getDirectDebitInfo>(
      this.urlService + "/Authenticate/getDirectDebitInfo",
      form
    );
  }
  getPersonalData(token, BAN) {
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    return this.http.post<getPersonalData>(
      this.urlService + "/Authenticate/GetPersonalData",
      form
    );
  }

  updatePersonalData(token, BAN, PhoneNumber, PhoneNumber2, Email) {
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    form.append("PhoneNumber", PhoneNumber);
    form.append("PhoneNumber2", PhoneNumber2);
    form.append("Email", Email);
    return this.http.post<updatePersonalData>(
      this.urlService + "/Authenticate/UpdatePersonalData",
      form
    );
  }
  updatePersonalDir(token, BAN, AddressDet, AddressDet2, City, zip) {
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    form.append("AddressDet", AddressDet);
    form.append("AddressDet2", AddressDet2);
    form.append("City", City);
    form.append("zip", zip);
    return this.http.post<updatePersonalDir>(
      this.urlService + "/Authenticate/UpdatePersonalDir",
      form
    );
  }
  getHistoricoFacturas(token, Ban, year, format) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("year", year);
    form.append("format", format);
    return this.http.post<getHistoricoFacturas>(
      this.urlService + "/Authenticate/GetHistoricalInvoices",
      form
    );
  }
  getHistoricoFacturasNew(token, Ban, year, format) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("year", year);
    form.append("format", format);
    return this.http.post<getHistoricoFacturasNew>(
      this.urlService + "/Authenticate/GetHistoricalInvoicesNew",
      form
    );
  }
  getHistoricalInvoiceOnDemand(token, Ban, key) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("key", key);
    return this.http.post<getHistoricalInvoiceOnDemand>(
      this.urlService + "/Authenticate/GetHistoricalInvoiceOnDemand",
      form
    );
  }

  getPaymentHistory(token, Ban, year) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("year", year);
    return this.http.post<getPaymentHistory>(
      this.urlService + "/Authenticate/GetPaymentHistory",
      form
    );
  }
  accountDetails(token, subscriber, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    form.append("account", account);
    return this.http.post<accountDetails>(
      this.urlService + "/Authenticate/AccountDetails",
      form
    );
  }

  accountDetailsIframe(token, subscriber, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    form.append("account", account);
    return this.http.post<accountDetails>(
      this.urlService + "/Authenticate/AccountDetails2",
      form
    );
  }

  addUser(Account, Amount, token) {
    var form = new FormData();
    form.append("Account", Account);
    form.append("Amount", Amount);
    form.append("token", token);
    return this.http.post<doPayment>(
      this.urlService + "/Authenticate/DoPayment",
      form
    );
  }
  doPayment(Account, Amount, token) {
    var form = new FormData();
    form.append("Account", Account);
    form.append("Amount", Amount);
    form.append("token", token);
    return this.http.post<doPayment>(
      this.urlService + "/Authenticate/DoPayment",
      form
    );
  }
  getAcounts(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<getAcountsList>(
      this.urlService + "/Authenticate/GetAcounts",
      form
    );
  }
  accountRefresh(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<accountRefresh>(
      this.urlService + "/Authenticate/accountRefresh",
      form
    );
  }
  addAccount(account, ssn, defaultAccount, token) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    form.append("ssn", ssn);
    form.append("setAsDefaultAccount", defaultAccount);
    return this.http.post<addAccount>(
      this.urlService + "/Authenticate/addAccount",
      form
    );
  }
  deleteAccount(token, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    return this.http.post<deleteAccount>(
      this.urlService + "/Authenticate/deleteAccount",
      form
    );
  }
  setAsDefaultAccount(
    account,
    subscriber,
    accountType,
    accountSubType,
    productType,
    token
  ) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    form.append("subscriber", subscriber);
    form.append("accountType", accountType);
    form.append("accountSubType", accountSubType);
    form.append("productType", productType);
    return this.http.post<setAsDefaultAccount>(
      this.urlService + "/Authenticate/setAsDefaultAccount",
      form
    );
  }
  getquestions(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<getquestions>(
      this.urlService + "/Authenticate/GetQuestions",
      form
    );
  }
  getVerifyEmail(email) {
    var form = new FormData();
    form.append("email", email);
    return this.http.post<getVerifyEmail>(
      this.urlService + "/Authenticate/GetVerifyEmail",
      form
    );
  }
  getChallengeQuestions2(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<getChallengeQuestions2>(
      this.urlService + "/Authenticate/GetChallengeQuestions2",
      form
    );
  }

  getChallengeQuestions3(subscriber, source) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("source", source);
    return this.http.post<getChallengeQuestions3>(
      this.urlService + "/Authenticate/GetChallengeQuestions",
      form
    );
  }
  getChallengeQuestions4(subscriber, source) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("source", source);
    return this.http.post<getChallengeQuestions3>(
      this.urlService + "/Authenticate/GetChallengeQuestions3",
      form
    );
  }

  getPasswordRecoveryBySubscriber(subscriber, email, sms) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("email", email);
    form.append("sms", sms);
    return this.http.post<getPasswordRecoveryBySubscriber>(
      this.urlService + "/Authenticate/GetPasswordRecoveryBySubscriber",
      form
    );
  }

  validateSubscriber(subscriber) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    return this.http.post<validateSubscriber>(
      this.urlService + "/Authenticate/ValidateSubscriber",
      form
    );
  }
  changePassword(token, password, newPassword) {
    var form = new FormData();
    form.append("token", token);
    form.append("password", password);
    form.append("newPassword", newPassword);
    return this.http.post<getpasswordrecovery>(
      this.urlService + "/Authenticate/ChangePassword",
      form
    );
  }
  getReferrals(token, account) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    return this.http.post<any>(
      this.urlService + "/Authenticate/getReferrals",
      form
    );
  }
  updatePaperless(Ban, token) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    return this.http.post<paperless>(
      this.urlService + "/Authenticate/UpdateBillParameters",
      form
    );
  }
  permissions(token, accountType, name, lastName) {
    var form = new FormData();
    form.append("token", token);
    form.append("accountType", accountType);
    form.append("name", name);
    form.append("lastName", lastName);
    return this.http.post<permissions>(
      this.urlService + "/Authenticate/permissions",
      form
    );
  }
  userList(idUser, idParent) {
    var form = new FormData();
    form.append("idUser", idUser);
    form.append("idParent", idParent);
    return this.http.post<userList>(
      this.urlService + "/Authenticate/userList",
      form
    );
  }
  rolesList() {
    var form = new FormData();
    return this.http.post<rolesList>(
      this.urlService + "/Authenticate/rolesList",
      form
    );
  }
  idRoleList(idRole) {
    var form = new FormData();
    form.append("idRole", idRole);
    return this.http.post<idRoleList>(
      this.urlService + "/Authenticate/idRoleList",
      form
    );
  }
  updateRoles(listRoles) {
    var data = {
      roles: listRoles,
    };
    return this.http.post<updateRoles>(
      this.urlService + "/Authenticate/updateRoles",
      data
    );
  }
  createUser(
    idUserAPP,
    idParent,
    idRole,
    name,
    lastname,
    email,
    phoneNumber,
    listRoles
  ) {
    var data = {
      idUserAPP: idUserAPP,
      idParent: idParent,
      idRole: idRole,
      name: name,
      lastname: lastname,
      email: email,
      phoneNumber: phoneNumber,
      roles: listRoles,
    };
    return this.http.post<createUser>(
      this.urlService + "/Authenticate/createUser",
      data
    );
  }
  validateSSNAndEmail(Subscriber, SSN, Email, Code) {
    var form = new FormData();
    form.append("Subscriber", Subscriber);
    form.append("SSN", SSN);
    form.append("Email", Email);
    form.append("Code", Code);
    return this.http.post<validateSSNAndEmail>(
      this.urlService + "/Authenticate/RegisterUserValidateSSNAndEmail",
      form
    );
  }
  updMessageStatus(account, token, id_message) {
    var form = new FormData();
    form.append("account", account);
    form.append("token", token);
    form.append("id_message", id_message);
    return this.http.post<updMessageStatus>(
      this.urlService + "/Authenticate/UpdMessageStatus",
      form
    );
  }
  setchallengequestions(token, questionID, response) {
    var form = new FormData();
    form.append("token", token);
    form.append("questionID", questionID);
    form.append("response", response);
    return this.http.post<setchallengequestions>(
      this.urlService + "/Authenticate/SetChallengeQuestions",
      form
    );
  }
  getpasswordrecovery(subscriber, ResponseList) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("ResponseList", ResponseList);
    return this.http.post<getpasswordrecovery>(
      this.urlService + "/Authenticate/Getpasswordrecovery",
      form
    );
  }
  setPasswordUpdate(token, currentPassword, newPassword) {
    var form = new FormData();
    form.append("token", token);
    form.append("currentPassword", currentPassword);
    form.append("newPassword", newPassword);
    return this.http.post<setPasswordUpdate>(
      this.urlService + "/Authenticate/SetPasswordUpdate",
      form
    );
  }
  changeUser(token, email) {
    var form = new FormData();
    form.append("token", token);
    form.append("email", email);
    return this.http.post<changeUser>(
      this.urlService + "/Authenticate/SetEmailAsUserAccount",
      form
    );
  }
  registerUser(Subscriber, SSN, Email, Password, Code) {
    var form = new FormData();
    form.append("Subscriber", Subscriber);
    form.append("SSN", SSN);
    form.append("Email", Email);
    form.append("Password", Password);
    form.append("Code", Code);
    return this.http.post<validatePassword>(
      this.urlService + "/Authenticate/RegisterUser",
      form
    );
  }
  lastInvoice(Ban, year, format, token) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("year", year);
    form.append("format", format);
    form.append("token", token);
    return this.http.post<getpasswordrecovery>(
      this.urlService + "/Authenticate/LastInvoice",
      form
    );
  }
  getInstallments(
    appId,
    queryType,
    valueRequested,
    accountNumber,
    subscriberNumber,
    productType,
    userId
  ) {
    var form = new FormData();
    form.append("appId", appId);
    form.append("queryType", queryType);
    form.append("valueRequested", valueRequested);
    form.append("accountNumber", accountNumber);
    form.append("subscriberNumber", subscriberNumber);
    form.append("productType", productType);
    form.append("userId", userId);
    return this.http.post<getInstallments>(
      this.urlService + "/Authenticate/getInstallments",
      form
    );
  }

  recoverPasswordValidate(code) {
    var form = new FormData();
    form.append("code", code);
    return this.http.post(
      this.urlService + "/Authenticate/recoverPasswordValidate",
      form
    );
  }

  recoverPasswordFinish(code, password) {
    var form = new FormData();
    form.append("code", code);
    form.append("password", password);
    return this.http.post(
      this.urlService + "/Authenticate/recoverPasswordFinish",
      form
    );
  }

  getEvaluatePlanPrepaid(token, subscriber, socId) {
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    form.append("socId", socId);
    return this.http.post(
      this.urlService + "/Authenticate/getEvaluatePlanPrepaid",
      form
    );
  }

  goToStore(tokenSSO: string, ban: string) {
    var form = new FormData();
    form.append("tokenSSO", tokenSSO);
    form.append("ban", ban);
    return this.http.post("http://shopqa.com/api/process/goToStore", form);
  }

  getIframeToken() {
    const form = new FormData();
    return this.http.post<any>(
      this.urlService + "/Authenticate/getToken",
      form
    );
  }

  subscriber(token, accountNumber, ssn, subscriber) {
    const form = new FormData();
    form.append("token", token);
    form.append("accountNumber", accountNumber);
    form.append("ssn", ssn);
    form.append("subscriber", subscriber);
    return this.http.post<any>(
      this.urlService + "/Authenticate/subscriber",
      form
    );
  }

  authenticateToken(tokenSSO) {
    const form = new FormData();
    const payload = {
      SSOAccessToken: tokenSSO,
    };
    let token = btoa(JSON.stringify(payload));

    form.append("token", token);
    return this.http.post<any>(
      this.urlService + "/Authenticate/authenticateToken",
      form
    );
  }
}
